import React from 'react';
import type { FormState } from '@types';

interface RatingFieldProps {
    label: string;
    textName: string;
    textValue: string;
    ratingName: string;
    ratingValue: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
    rows?: number;
}

const RatingField: React.FC<RatingFieldProps> = ({ label, textName, textValue, ratingName, ratingValue, onChange, rows = 3 }) => {
    return (
        <div className="bg-slate-50 border border-slate-200 rounded-lg p-4">
            <label htmlFor={textName} className="block text-sm font-medium text-slate-700 mb-2">{label}</label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <textarea
                    id={textName}
                    name={textName}
                    value={textValue || ''}
                    onChange={onChange}
                    rows={rows}
                    className="w-full bg-white border border-slate-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none transition-colors md:col-span-2"
                    placeholder="Describe the current state of this control..."
                />
                <div className="self-center">
                     <label htmlFor={ratingName} className="sr-only">Rating for {label}</label>
                    <select
                        id={ratingName}
                        name={ratingName}
                        value={ratingValue || 'na'}
                        onChange={onChange}
                        className="w-full bg-white border border-slate-300 rounded-md p-2 focus:ring-2 focus:ring-blue-500 focus:outline-none transition-colors font-semibold"
                    >
                        <option value="na">Not Applicable</option>
                        <option value="good">Good</option>
                        <option value="fair">Fair</option>
                        <option value="poor">Poor</option>
                    </select>
                     <p className="text-xs text-slate-500 mt-1">Rate the effectiveness of this control.</p>
                </div>
            </div>
        </div>
    );
};

export default RatingField;